import {
  ASSIGNMENT_DETAILS_FETCHED,
  DUMMY_OFF
} from './mle-actions';

const initialState = {
  productId: 1,
  teacherProfileId: null,
  assignmentId: '',
  assessmentId: null,
  assessmentVersion: null,
  assessmentType: null,
  name: '',
  isInProgress: false,
  isCompleted: false,
  durationInSeconds: null,
  durationType: 0,
  timeLeftInSeconds: null,
  student: {
    firstName: '',
    lastName: ''
  },
  questions: [],
  questionIndex: null,
  isDummy: true
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ASSIGNMENT_DETAILS_FETCHED: {
      return action.payload;
    }

    case DUMMY_OFF: {
      return {
        ...state,
        isDummy: false
      };
    }

    default:
      return state;
  }
};
